import {
  ADD_SKU,
  EDIT_SKU,
  REMOVE_SKU,
  SET_CODE,
  SET_DESCRIPTION,
  SET_END_DATE,
  SET_NAME,
  SET_PRODUCT_LINE_CODE,
  SET_SKU,
  SET_SP_CODE,
} from "./constants";
import { IOfferingSKURank } from "../../../../../services/api/offering/types";
import {
  IAddSKUAction,
  IEditSKUAction,
  IRemoveSKUAction,
  ISetCodeAction,
  ISetDescriptionAction,
  ISetEndDateAction,
  ISetNameAction,
  ISetProductLineCodeAction,
  ISetSKUAction,
  ISetSpCodeAction,
} from "./types";

export const setName = (payload: string): ISetNameAction => {
  return {
    type: SET_NAME,
    payload,
  };
};

export const setCode = (payload: string): ISetCodeAction => {
  return {
    type: SET_CODE,
    payload,
  };
};

export const setProductLineCode = (
  payload: string,
): ISetProductLineCodeAction => {
  return {
    type: SET_PRODUCT_LINE_CODE,
    payload,
  };
};

export const setSpCode = (payload: string): ISetSpCodeAction => {
  return {
    type: SET_SP_CODE,
    payload,
  };
};

export const setEndDate = (payload: string): ISetEndDateAction => {
  return {
    type: SET_END_DATE,
    payload,
  };
};

export const setDescription = (payload: string): ISetDescriptionAction => {
  return {
    type: SET_DESCRIPTION,
    payload,
  };
};

export const setSKU = (payload: IOfferingSKURank[]): ISetSKUAction => {
  return {
    type: SET_SKU,
    payload,
  };
};

export const addSKU = (): IAddSKUAction => {
  return {
    type: ADD_SKU,
  };
};

export const editSKU = (payload: IOfferingSKURank): IEditSKUAction => {
  return {
    type: EDIT_SKU,
    payload,
  };
};

export const removeSKU = (): IRemoveSKUAction => {
  return {
    type: REMOVE_SKU,
  };
};
